import * as React from "react";
import styled from "styled-components";
import Web3 from "web3";
// @ts-ignore
import Web3Modal from "web3modal";
// @ts-ignore
import WalletConnect from "@walletconnect/web3-provider";
// @ts-ignore
import CoinbaseWalletSDK from "@coinbase/wallet-sdk";
// @ts-ignore
import Torus from "@toruslabs/torus-embed";

import Column from "./components/Column";
import Header from "./components/Header";
import { getChainData } from "./helpers/utilities";
import { INFURA_ID, RPC_URL, CHAIN_ID } from "constants/config"

import Home from "views/Home"

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Moralis from "moralis";

const Background = styled.div`
  background: url(/images/background.jpg);
  background-size: cover;
  width: 100%;
  height: 100vh;
  position: fixed;
  z-index: -1;
`

const SLayout = styled.div`
  position: relative;
  width: 100%;
  min-height: 100vh;
  text-align: center;
  background: #00000080;
`;

const BlackBackground = styled.div`
  background: #00000010;
  height: 100vh;
  position: fixed;
`

const MarkArea = styled.div`
  color: white;
  position: fixed;
  bottom: 10px;
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0 15px;
`

interface IAppState {
  address: string;
  web3: any;
  provider: any;
  connected: boolean;
  chainId: number;
  networkId: number;
}

const INITIAL_STATE: IAppState = {
  address: "",
  web3: null,
  provider: null,
  connected: false,
  chainId: 5,
  networkId: 5,
};

function initWeb3(provider: any) {
  const web3: any = new Web3(provider);

  web3.eth.extend({
    methods: [
      {
        name: "chainId",
        call: "eth_chainId",
        outputFormatter: web3.utils.hexToNumber
      }
    ]
  });

  return web3;
}

class App extends React.Component<any, any> {
  // @ts-ignore
  public web3Modal: Web3Modal;
  public state: IAppState;

  // await Moralis.start({
    //   apiKey: 'viTvS6kkXNRDB528aLav7UDz9TBY9Yf6Gej9fNwSCGFFpu4ivbaYglzaExBFnsqs'
    // })

  constructor(props: any) {
    super(props);
    this.state = {
      ...INITIAL_STATE
    };

    this.web3Modal = new Web3Modal({
      network: this.getNetwork(),
      cacheProvider: true,
      providerOptions: this.getProviderOptions()
    });
  }

  public componentDidMount() {
    if (this.web3Modal.cachedProvider) {
      this.onConnect();
    }
  }

  public onConnect = async () => {
    const provider = await this.web3Modal.connect();

    await this.subscribeProvider(provider);

    await provider.enable();
    const web3: any = initWeb3(provider);

    const accounts = await web3.eth.getAccounts();

    const address = accounts[0];

    const networkId = await web3.eth.net.getId();

    const chainId = await web3.eth.chainId();

    // console.log("Beast", web3, networkId, chainId)
    // await Moralis.start({
    //   apiKey: 'viTvS6kkXNRDB528aLav7UDz9TBY9Yf6Gej9fNwSCGFFpu4ivbaYglzaExBFnsqs'
    // })

    if (chainId !== CHAIN_ID) {
      try {
        await window.ethereum.request({
          method: 'wallet_switchEthereumChain',
          params: [{ chainId: web3.utils.toHex(CHAIN_ID) }],
        });
        // console.log("Beast", web3, window)
      }
      catch(error) {
        console.log("Switch error", error)
      }
    }

    await this.setState({
      web3,
      provider,
      connected: true,
      address,
      chainId,
      networkId
    });
    this.startMoralis()
  };

  public startMoralis = async() => {
    await Moralis.start({
      apiKey: 'viTvS6kkXNRDB528aLav7UDz9TBY9Yf6Gej9fNwSCGFFpu4ivbaYglzaExBFnsqs'
    })
  }

  public subscribeProvider = async (provider: any) => {
    provider.on("close", () => this.resetApp());
    provider.on("accountsChanged", async (accounts: string[]) => {
      await this.setState({ address: accounts[0] });
    });
    provider.on("chainChanged", async (chainId: number) => {
      const { web3 } = this.state;
      const networkId = await web3.eth.net.getId();
      // console.log("Beast chain changed", networkId)
      if (CHAIN_ID !== networkId) {
        toast.error("Please change the network to Avalanche");
        this.resetApp()
        return;
      }
      await this.setState({ chainId, networkId });
    });

    provider.on("networkChanged", async (networkId: number) => {
      const { web3 } = this.state;
      const chainId = await web3.eth.chainId();
      await this.setState({ chainId, networkId });
    });
  };

  public getNetwork = () => getChainData(this.state.chainId).network;

  public getProviderOptions = () => {
    const providerOptions = {
      walletconnect: {
        package: WalletConnect,
        options: {
          rpc: {
              [5]: RPC_URL,
          },
        }
      }
    };
    return providerOptions;
  };

  public resetApp = async () => {
    const { web3 } = this.state;
    if (web3 && web3.currentProvider && web3.currentProvider.close) {
      await web3.currentProvider.close();
    }
    await this.web3Modal.clearCachedProvider();
    this.setState({ ...INITIAL_STATE });
  };

  // useEffect(() => {
  //   const loadMoralis = async () => {
  //     if (!Moralis.Core.isStarted) {
  //       await Moralis.start({
  //         apiKey: 'viTvS6kkXNRDB528aLav7UDz9TBY9Yf6Gej9fNwSCGFFpu4ivbaYglzaExBFnsqs'
  //       })
  //     }
  //   }
  //   loadMoralis();
  // }, []);

  public render = () => {
    const {
      web3,
      address,
      connected,
      chainId,
    } = this.state;
    return (
      <SLayout>
        <Background/>
        <BlackBackground />
        <Column maxWidth={1280} spanHeight>
          <Header
            connected={connected}
            address={address}
            chainId={chainId}
            killSession={this.resetApp}
            walletConnect={this.onConnect}
          />
          <Home web3={web3} address={address} chainId={chainId} />
        </Column>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss={false}
          draggable
          pauseOnHover={false}
        />
        <MarkArea>
          <div>10,013 VM SHIPS</div>
          <div>© 2023 VendingMachine</div>
        </MarkArea>
      </SLayout>
    );
  };
}

export default App;
